import { NavLink, NavLinkProps } from 'react-router-dom'
import { ReactNode } from 'react'

export interface INavLinkItemProps extends NavLinkProps {
  icon?: ReactNode
  label?: string
  children: string
}

export const NavLinkItem = ({ icon, label, children, to, hidden }: INavLinkItemProps) => {
  return (
    <NavLink
      className={({ isActive }) =>
        `flex w-full items-center gap-3 rounded-[8px] p-2 text-focus-500 transition-all duration-150 hover:bg-default-200 hover:text-default ${isActive && 'text-default'} ${isActive && 'bg-default-200'}`
      }
      hidden={hidden}
      to={to}
    >
      <>
        {icon}
        {children}
        {label && (
          <span
            className={'rounded-[2px] border-[1px] px-1 text-[9px] uppercase leading-4 text-success-400'}
          >
            {label}
          </span>
        )}
      </>
    </NavLink>
  )
}
